var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.roleRules.GRAD_PROG_FLG === "Y"
    ? _c(
        "div",
        { staticStyle: { "margin-left": "7px" } },
        [
          _vm.roleRules.GRAD_REQ_CATEGORIES === "Y"
            ? [
                !!_vm.graduationRequirements.HEADER_TEXT &&
                _vm.graduationRequirements.HEADER_TEXT.length > 0
                  ? _c("div", {
                      staticClass: "instructions alert alert-info",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.graduationRequirements.HEADER_TEXT
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.graduationRequirementsKeys, function(req) {
                  return _c(
                    "div",
                    { key: req },
                    [
                      !!_vm.graduationRequirements.categories[req].ITEMS &&
                      _vm.graduationRequirements.categories[req].ITEMS.length
                        ? [
                            _c("h1", { staticClass: "gray-header" }, [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.graduationRequirements.categories[req]
                                      .CATEGORY_DESC
                                  ) +
                                  "\n\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _vm.graduationRequirements.categories[req]
                              .COMPLETED_FLG === "Y"
                              ? _c(
                                  "h2",
                                  {
                                    staticStyle: {
                                      "margin-left": "15px",
                                      "text-transform": "none"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.GraduationProgressReport.CourseWorkRequirementsMet",
                                            {
                                              student:
                                                _vm.selectedStudent.FIRST_NAME,
                                              requirement:
                                                _vm.graduationRequirements
                                                  .categories[req].CATEGORY_DESC
                                            }
                                          )
                                        ) +
                                        "\n\t\t\t\t"
                                    )
                                  ]
                                )
                              : _c(
                                  "h2",
                                  {
                                    staticStyle: {
                                      "margin-left": "15px",
                                      "text-transform": "none"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.GraduationProgressReport.CourseWorkRequirementsNotMet",
                                            {
                                              student:
                                                _vm.selectedStudent.FIRST_NAME,
                                              requirement:
                                                _vm.graduationRequirements
                                                  .categories[req].CATEGORY_DESC
                                            }
                                          )
                                        ) +
                                        "\n\t\t\t\t"
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.roleRules.GRAD_REQ_ITEMS === "Y" &&
                            !!_vm.graduationRequirements.categories[req]
                              .ITEMS &&
                            _vm.graduationRequirements.categories[req].ITEMS
                              .length
                              ? _c("div", { staticClass: "table-responsive" }, [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-striped table-bordered default-table",
                                      attrs: { tabindex: "0" }
                                    },
                                    [
                                      _vm._m(0, true),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.graduationRequirements.categories[
                                            req
                                          ].ITEMS,
                                          function(item, itemIdx) {
                                            return _c(
                                              "tr",
                                              {
                                                key:
                                                  "item-" +
                                                  item.CATEGORY_CODE +
                                                  "-" +
                                                  item.ITEM_CODE +
                                                  "_" +
                                                  itemIdx
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  { attrs: { tabindex: "0" } },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            item.ITEM_DESC
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _vm.roleRules
                                                      .GRAD_REQ_SUBITEMS ===
                                                      "Y" &&
                                                    !!item.SUBITEMS &&
                                                    item.SUBITEMS.length > 0
                                                      ? _c(
                                                          "ul",
                                                          _vm._l(
                                                            item.SUBITEMS,
                                                            function(
                                                              subitem,
                                                              subitemIdx
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  key:
                                                                    "item-" +
                                                                    item.CATEGORY_CODE +
                                                                    "-" +
                                                                    item.ITEM_CODE +
                                                                    "_" +
                                                                    itemIdx +
                                                                    "_" +
                                                                    subitem.SUBITEM_CODE +
                                                                    "_" +
                                                                    subitemIdx
                                                                },
                                                                [
                                                                  subitem.MULTIPLE_ALLOWED_FLG ==
                                                                  "Y"
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "(" +
                                                                              _vm._s(
                                                                                subitem.COUNT_INT
                                                                              ) +
                                                                              ") "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      subitem.SUBITEM_DESC
                                                                    ) +
                                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { tabindex: "0" } },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-v-531c1c6d": ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              item.STATUS_DESC
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.dataExists && _vm.roleRules.GRAD_COURSE_WORK === "Y"
            ? _c("h1", { staticClass: "gray-header" }, [
                _vm._v(
                  "\n\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.GraduationProgressReport.CourseWorkRequirements"
                      )
                    ) +
                    "\n\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dataExists && _vm.roleRules.GRAD_COURSE_WORK === "Y"
            ? _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  [
                    _vm._l(_vm.byDepartmentData, function(department, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c(
                            "panel-basic",
                            {
                              attrs: {
                                title: department.GRAD_RULE_NAME,
                                id: "department_" + index,
                                collapsable: true,
                                headingLevel: 3
                              }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(department.GRAD_RULE_NAME) +
                                    "\n\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.GraduationProgressReport.creditsRequiredWithColon"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-lg" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        department.TOTAL_CREDITS.toPrecision(4)
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-3" },
                                  [
                                    _c("progress-bar", {
                                      attrs: {
                                        id: "progress_bar_department_" + index,
                                        percent: _vm.getPercent(department),
                                        size: "sm"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-sm-9" }, [
                                  department.RULE_SATISFIED === "Y"
                                    ? _c(
                                        "p",
                                        { staticClass: "text-right" },
                                        [
                                          department.CREDITS_EARNED <
                                          department.TOTAL_CREDITS
                                            ? [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.GraduationProgressReport.departmentRequirementsSatisfiedUponCompletion"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.GraduationProgressReport.requirementHasBeenSatisfiedWithPeriod"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c("progress-report-departments", {
                                attrs: {
                                  departmentColumnsConfig:
                                    _vm.graduationProgressByDepartment,
                                  tableData: department
                                }
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row panel-summary-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "panel-summary panel-summary-success col-xs-12 col-md-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "panel-header" },
                                        [
                                          _c("h4", { staticClass: "title" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "MAIN_CONTENT.GraduationProgressReport.creditsEarned"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-center" },
                                            [
                                              _c(
                                                "strong",
                                                { staticClass: "total" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm._f("fixed")(
                                                          department.CREDITS_EARNED,
                                                          3
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "unit" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.GraduationProgressReport.creditsAllCaps"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "panel-summary panel-summary-info col-xs-12 col-md-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "panel-header" },
                                        [
                                          _c("h4", { staticClass: "title" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "MAIN_CONTENT.GraduationProgressReport.creditsInProgress"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-center" },
                                            [
                                              _c(
                                                "strong",
                                                { staticClass: "total" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm._f("fixed")(
                                                          department.CREDITS_IN_PROGRESS,
                                                          3
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "unit" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.GraduationProgressReport.creditsAllCaps"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "panel-summary panel-summary-warning col-xs-12 col-md-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "panel-header" },
                                        [
                                          _c("h4", { staticClass: "title" }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.GraduationProgressReport.creditsStillNeededFirstLettersCapatilized"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-center" },
                                            [
                                              _c(
                                                "strong",
                                                { staticClass: "total" },
                                                [
                                                  +department.CREDITS_IN_PROGRESS +
                                                    +department.CREDITS_EARNED <=
                                                  +department.TOTAL_CREDITS
                                                    ? [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm._f("fixed")(
                                                                department.TOTAL_CREDITS -
                                                                  department.CREDITS_EARNED -
                                                                  department.CREDITS_IN_PROGRESS,
                                                                3
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm._f("fixed")(
                                                                0,
                                                                3
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "unit" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MAIN_CONTENT.GraduationProgressReport.creditsAllCaps"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    [
                      _c(
                        "panel-basic",
                        {
                          attrs: {
                            title: _vm.$t(
                              "MAIN_CONTENT.GraduationProgressReport.summary"
                            ),
                            id: "yearly-summary",
                            collapsable: true,
                            headingLevel: 3
                          }
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.GraduationProgressReport.summary"
                                  )
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("strong", [
                            _c("div", { staticClass: "col-xs-9" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.GraduationProgressReport.totalCreditsRequirement"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-3",
                                staticStyle: { "text-align": "right" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.GraduationProgressReport.totalCreditsNeededWithColon",
                                        {
                                          credits: _vm.$options.filters.fixed(
                                            _vm.graduationProgressData
                                              .TRACK_INFO.TOTAL_CREDITS,
                                            3
                                          )
                                        }
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("progress-report-years", {
                            staticClass: "col-xs-12",
                            attrs: {
                              yearColumnsConfig: _vm.graduationProgressByYear,
                              tableData: _vm.totalRequirements
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "panel-summary-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "panel-summary panel-summary-success col-xs-12 col-md-4"
                              },
                              [
                                _c("div", { staticClass: "panel-header" }, [
                                  _c("h4", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.GraduationProgressReport.creditsEarned"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-center" }, [
                                    _c("strong", { staticClass: "total" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("fixed")(
                                              _vm.graduationProgressData
                                                .TRACK_INFO.CREDITS_EARNED,
                                              3
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.GraduationProgressReport.creditsAllCaps"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "panel-summary panel-summary-info col-xs-12 col-md-4"
                              },
                              [
                                _c("div", { staticClass: "panel-header" }, [
                                  _c("h4", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.GraduationProgressReport.creditsInProgress"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-center" }, [
                                    _c("strong", { staticClass: "total" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("fixed")(
                                              _vm.graduationProgressData
                                                .TRACK_INFO.CREDITS_IN_PROGRESS,
                                              3
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.GraduationProgressReport.creditsAllCaps"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "panel-summary panel-summary-warning col-xs-12 col-md-4"
                              },
                              [
                                _c("div", { staticClass: "panel-header" }, [
                                  _c("h4", { staticClass: "title" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.GraduationProgressReport.creditsStillNeededFirstLettersCapatilized"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-center" }, [
                                    _c("strong", { staticClass: "total" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("fixed")(
                                              _vm.stillNeededCredits,
                                              3
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.GraduationProgressReport.creditsAllCaps"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ]
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.roleRules.GRAD_PROG_FLG !== "Y"
            ? [
                _vm._v(
                  "\n\t\t" +
                    _vm._s(
                      _vm.$t("MAIN_CONTENT.commonContent.invalidPermissions")
                    ) +
                    "\n\t"
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "auto", tabindex: "0", scope: "col" } }, [
          _vm._v("\n\t\t\t\t\t\t\t\t\tRequirement\n\t\t\t\t\t\t\t\t")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { width: "auto", tabindex: "0", scope: "col" } }, [
          _vm._v("\n\t\t\t\t\t\t\t\t\tStatus\n\t\t\t\t\t\t\t\t")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }